"use client"

import { useTheme } from "next-themes"
import { Toaster as Sonner } from "sonner"

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
    const { resolvedTheme } = useTheme()
    return (
        <Sonner
            className="toaster group"
            closeButton
            theme={resolvedTheme as ToasterProps["theme"]}
            {...props}
        />
    )
}

export { Toaster }
